import {Inject, Injectable} from 'ng-metadata/core';
import {AddQueryToSavedSearchesService} from "../../search/savedQueries/addQueryToSavedSearches/addQueryToSavedSearches.service";

let annyang = require('annyang');

@Injectable()
export class VoiceSearchToastService {
    public lastVoiceSearchLanguage:string;
    public mainSearchField:string;
    public voiceSearchTitle:string;
    public waitingVoiceSearchTimerDidntGetIt1;
    public waitingVoiceSearchTimerDidntGetIt2;
    public waitingVoiceSearchTimerDidntGetItCheck;

    constructor(    @Inject('$translate') private $translate: ng.translate.ITranslateService,
                    @Inject('$timeout') private $timeout: angular.ITimeoutService,
                    @Inject('$mdToast') private $mdToast: ng.material.IToastService){
    }

    /**
     * Changes the toast text and closes the toast after speech was recognized
     */
    public executeVoiceSearch(searchString) {
        let searchTermDisplayTime = 2500;
        this.voiceSearchTitle = searchString; 
        this.cancelTimers();
        if(this.voiceSearchTitle.length > 20){
            searchTermDisplayTime = 5000;
        }
        this.$timeout(()=>{
            this.mainSearchField = '';
            this.voiceSearchTitle = '';
            this.onDismiss();
        }, searchTermDisplayTime);
    }
    
     /**
     * Called when closing the toast
     */
    public onDismiss() {
        this.cancelTimers()
        this.$mdToast.hide();
        if (annyang) {
            annyang.removeCallback();// Remove all callbacks
            annyang.abort();
        }
    }
    
     /**
     * Canceling Timers after specific events
     */
    public cancelTimers() {
        this.$timeout.cancel(this.waitingVoiceSearchTimerDidntGetIt1);
        this.$timeout.cancel(this.waitingVoiceSearchTimerDidntGetIt2);
        this.$timeout.cancel(this.waitingVoiceSearchTimerDidntGetItCheck);
    }
    
    
    
    
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/searchBar/voiceSearchToast.service.ts